<template lang="pug">
  dv-form(
    ref="form"
    v-model="formData"
    :schema="schema"
    :nestable="false"
    v-slot="{ fields }"
  )
    v-sheet.d-flex.gap-16(
      color="transparent"
      width="100%"
    )
      .d-flex(
        v-if="$slots.prepend"
        style="margin-top: 46px;"
      )
        slot(name="prepend")
      .d-flex.flex-grow-1.gap-18
        dv-form-nested.full-width(
          :field="fields.media"
        )
        v-icon.fit-content-height(
          color="ui-neutral lighten-1"
          style="margin-top: 44px;"
        ) $ui-route
        dv-form-field.full-width(
          :field="fields.pair"
        )
      .d-flex(style="margin-top: 46px;")
        dv-btn.ui-neutral.lighten-4.mt-n3(
          icon
          large
          :disabled="!canDelete"
          @click="$emit('delete')"
        )
          v-icon(color="ui-error") $ui-delete
</template>

<script>
import DvTextOrImageField from '@/packages/ui/components/inputs/DvTextOrImageField.vue';
import DvFormNested from '@/packages/ui/components/forms/DvFormNested.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvForm from '@/packages/ui/components/forms/DvForm.vue';
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvFormField,
    DvFormNested,
    DvForm,
    DvBtn,
  },
  props: {
    canDelete: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    schema() {
      return [
        {
          name: 'media',
          label: '1 часть',
          rules: 'required_fill',
          component: DvTextOrImageField,
          props: {
            imageKey: 'images',
            returnMultiple: true,
          },
        },
        {
          name: 'pair',
          value: 'pair',
          label: '2 часть',
          rules: 'required_fill',
          component: DvTextOrImageField,
          props: {
            nestable: false,
          },
        },
      ];
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
        this.$refs.form.reset(val);
      },
      deep: true,
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
};
</script>
